import { StyleObject } from 'styletron-react';

export const containerStyles = (horizontal: any) => {
    return {
        display: 'flex',
        flexDirection: 'column',
        gridAutoRows: 'max-content',
        overflow: 'hidden',
        boxSizing: 'border-box',
        appearance: 'none',
        outline: 'none',
        minWidth: '350px',
        minHeight: '200px',
        transition: 'background-color 350ms ease',
        borderBottom: '1px solid var(--epods--color-bluegrey-100)',
        fontSize: '1em',
        width: horizontal && '100%',
    } as StyleObject;
}

export const componentListStyles = (horizontal: any) => {
    return {
        display: 'grid',
        gridGap: '10px',
        gridTemplateColumns: 'repeat(var(--columns, 1), 1fr)',
        gridAutoFlow: horizontal ? 'column' : 'row',
        listStyle: 'none',
        padding: '16px',
        margin: '0',
    } as StyleObject;
}

export const headerStyles = {
    display: 'flex',
    padding: '5px 20px',
    paddingRight: '8px',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#fff',
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
} as StyleObject;

export const actionsStyles = {
    display: 'flex',
} as StyleObject;
